export const TOGGLE_VIEW_MODE = "TOGGLE_VIEW_MODE";
export const CHANGE_THRESHOLD = "CHANGE_THRESHOLD";
export const SET_CURRENT_EVENT_HEIGHT = "SET_CURRENT_EVENT_HEIGHT";
